import { flowRight as compose } from 'lodash';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';
import withUser from '~lib/common/hoc/withUser';

import CaseAvatar from './CaseAvatar.vue';
import queries from '~lib/common/queries/Avatar';

const enhance = compose(
  dataView({ queries }),
  renameProps({ data: 'avatars' }),
  withUser()
);

export default enhance(CaseAvatar);
